<template>
  <ul class="social-links" :style="{ display: isInBottomNavbar ? 'flex' : 'none'  }">
    <li class="social-links__item">
      <FacebookIcon :color="color" />
    </li>
    <li class="social-links__item">
      <InstagramIcon :color="color" />
    </li>
    <li class="social-links__item">
      <TwitterIcon :color="color" />
    </li>
  </ul>
</template>

<script>
import FacebookIcon from '@/components/svg/FacebookIcon';
import InstagramIcon from '@/components/svg/InstagramIcon';
import TwitterIcon from '@/components/svg/TwitterIcon';

export default {
  name: 'SocialLinks',
  props: {
    color: {
      type: String,
      default: 'white',
    },
    isInBottomNavbar: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    FacebookIcon,
    InstagramIcon,
    TwitterIcon,
  },
};
</script>

<style scoped lang="scss">
.social-links {
  margin: 0;
  padding: 0;
  list-style: none;
  display: none;

  @media screen and (max-width: $mobile) {
    display: flex;
  }

  &__item {
    &:not(:last-child) {
      margin-right: 20px;
    }
  }
}
</style>